import { useEffect, useState } from "react";

interface ShareBarProps {
  title: string;
}

export default function ShareBar({ title }: ShareBarProps) {
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!message) return;
    const timer = window.setTimeout(() => setMessage(""), 2600);
    return () => window.clearTimeout(timer);
  }, [message]);

  const currentUrl = () => window.location.href.split("#")[0];

  const handleCopy = async () => {
    const url = currentUrl();
    try {
      await navigator.clipboard.writeText(url);
      setMessage("链接已复制，可以粘贴分享给朋友");
    } catch {
      const textarea = document.createElement("textarea");
      textarea.value = url;
      textarea.style.position = "fixed";
      textarea.style.opacity = "0";
      document.body.appendChild(textarea);
      textarea.select();
      const ok = document.execCommand("copy");
      document.body.removeChild(textarea);
      setMessage(ok ? "链接已复制，可以粘贴分享给朋友" : "复制失败，请手动复制地址栏链接");
    }
  };

  const handleWeibo = () => {
    window.open(
      `https://service.weibo.com/share/share.php?url=${encodeURIComponent(currentUrl())}&title=${encodeURIComponent(title)}`,
      "_blank",
      "noopener,noreferrer",
    );
  };

  return (
    <div className="relative flex flex-wrap items-center gap-2">
      <span className="mr-1 text-xs text-foreground-400">分享</span>
      <button
        type="button"
        onClick={handleCopy}
        className="flex cursor-pointer items-center gap-1.5 rounded-md border border-background-300 bg-background-50 px-2.5 py-1.5 text-xs text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
      >
        <i className="ri-link" aria-hidden="true" />
        复制链接
      </button>
      <button
        type="button"
        onClick={handleWeibo}
        className="flex cursor-pointer items-center gap-1.5 rounded-md border border-background-300 bg-background-50 px-2.5 py-1.5 text-xs text-foreground-700 transition-colors hover:border-accent-300 hover:text-accent-700"
      >
        <i className="ri-weibo-line" aria-hidden="true" />
        微博
      </button>
      <button
        type="button"
        onClick={() => setMessage("微信暂未接入分享接口，请复制链接后在微信中粘贴分享")}
        className="flex cursor-pointer items-center gap-1.5 rounded-md border border-background-300 bg-background-50 px-2.5 py-1.5 text-xs text-foreground-700 transition-colors hover:border-secondary-300 hover:text-secondary-700"
      >
        <i className="ri-wechat-line" aria-hidden="true" />
        微信
      </button>
      {message && (
        <span className="absolute -bottom-9 left-0 z-10 rounded-md bg-foreground-900 px-2.5 py-1.5 text-xs text-background-50">
          {message}
        </span>
      )}
    </div>
  );
}